<template>
  <div class="product-filter-item-component">
    <div class="filter-item-title"
         :class="{ choose: selectOptions.length > 0 }"
         @click="handleFilterTitle"
    >
      {{ filterData | itemName }}
      <ym-icon class="icon-down"
                :class="{ active: filterData.selected }"
                name="down-fill"
      />
    </div>
    <div class="filter-item-content"
         :class="{ active: filterData.selected }"
         @click="handleFilterContent"
    >
      <div class="block-list"
           v-for="(blockListItem, blockListIndex) in filterData.blockList"
           :key="blockListIndex"
      >
        <div class="filter-list-block"
             v-for="(filterListItem, filterListIndex) in blockListItem.filterList"
             :key="filterListIndex"
        >
          <div class="name"
               :class="{ 'center': filterListItem.name.style === 'center',
                 'left': filterListItem.name.style === 'left' }"
               v-if="filterListItem.name"
          >
            {{ filterListItem.name.text }}
          </div>
          <div class="option-list">
            <div class="option-item"
                 :class="{ 'active': isCurrOptionSelect(`${blockListItem.key}=${item.value}`) }"
                 v-for="(item, index) in filterListItem.list"
                 :key="index"
                 @click.stop="handleOptionItem(blockListItem.key,
                    item.value, filterListItem.isMultiSelect, filterData.toolBar, item.name)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="tool-bar"
           v-if="filterData.toolBar"
      >
        <div class="cancel"
             v-if="filterData.toolBar.cancelText !== ''"
        >
          {{ filterData.toolBar.cancelText }}
        </div>
        <div class="reset"
             @click.stop="handleConfirm(filterData.toolBar, 'reset')"
             v-if="filterData.toolBar.resetText !== ''"
        >
          {{ filterData.toolBar.resetText }}
        </div>
        <div class="confirm"
             @click.stop="handleConfirm(filterData.toolBar, 'confirm')"
             v-if="filterData.toolBar.confirmText !== ''"
        >
          {{ filterData.toolBar.confirmText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductFilterItemBlock',
    props: {
      item: {
        type: Object,
        required: true,
      },
      params: {
        type: Array,
      },
    },
    data() {
      return {
        filterData: null,
        selectOptions: [],
        filterResult: [],
      };
    },
    watch: {
      item(val) {
        this.filterData = val;
      },
      params(val) {
        this.selectOptions = val;
      },
    },
    filters: {
      itemName(data) {
        const { activeName, name } = data;
        return activeName && activeName !== '' ? activeName : name;
      },
    },
    methods: {
      initFilterBarTitle(params) {
        if (params.length === 0) {
          this.filterData.activeName = '';
          return;
        }
        this.filterData.blockList.forEach((blockListItem) => {
          const selectOption = params.find(item => item.split('=')[0] === blockListItem.key);
          if (selectOption && this.filterData.needReplaceTitle) {
            blockListItem.filterList.forEach((filterListItem) => {
              const selectItem = filterListItem.list.find(item => item.value === selectOption.split('=')[1]);
              if (selectItem) {
                this.selectOptions.push(selectOption);
                this.filterResult.push(selectOption);
                this.filterData.activeName = selectItem.name;
              }
            });
          } else {
            this.filterData.activeName = '';
          }
        });
      },

      isCurrOptionSelect(option) {
        return this.selectOptions.includes(option);
      },

      handleFilterTitle() {
        this.$emit('filterTitle', this.filterData.name);
      },

      handleFilterContent() {
        this.$emit('filterTitle', this.filterData.name);
      },

      handleReplaceFilterTitle(name) {
        if (this.filterData.needReplaceTitle) {
          this.filterData.activeName = name;
        } else {
          this.filterData.activeName = '';
        }
      },

      handleOptionItem(key, value, isMultiSelect, toolBar, name) {
        const currOption = `${key}=${value}`;
        const { selectOptions } = this;

        // 已存在
        if (selectOptions.find(item => item === currOption)) {
          this.handleDeleteOption(currOption, toolBar);
          return;
        }

        // 不可多选
        if (!isMultiSelect && selectOptions.find(item => item.includes(key))) {
          this.selectOptions.splice(selectOptions.findIndex(item => item.includes(key)), 1);
        }

        this.selectOptions.push(currOption);
        this.handleReplaceFilterTitle(name);
        this.handleConfirm(toolBar, 'option');
      },

      handleDeleteOption(currOption, toolBar) {
        this.selectOptions.splice(this.selectOptions.findIndex(item => item === currOption), 1);
        if (this.filterData.needReplaceTitle && this.selectOptions.length === 0) {
          this.filterData.activeName = '';
        }
        this.$emit('delete', currOption);
        this.handleConfirm(toolBar, 'option');
      },

      handleConfirm(toolBar, type) {
        if (type === 'confirm') {
          this.handleFilterContent();
          this.$emit('confirm', this.fetchParams());
          return;
        }
        if (type === 'reset') {
          this.$emit('reset', this.fetchParams());
          this.selectOptions = [];
          this.handleFilterContent();
          return;
        }
        if (toolBar == null) {
          this.handleFilterContent();
          this.$emit('confirm', this.fetchParams(), 'delete');
        }
      },


      handleCancel() {},

      fetchParams() {
        if (this.selectOptions.length === 0) return {};
        const params = {};
        this.selectOptions.forEach((item) => {
          const key = item.split('=')[0];
          const value = item.split('=')[1];
          params[key] = value;
        });
        return params;
      },
    },
    created() {
      this.filterData = this.item;
      this.initFilterBarTitle(this.params);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-filter-item-component {
    flex: 1;
  }

  .filter-item-title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @color-text-light;
    &.choose {
      color: @color-text-primary;
      .icon-down {
        color: @color-text-primary;
      }
    }
    .icon-down {
      &.active {
        transform:rotate(180deg);
      }
    }
  }

  .icon-down {
    flex-shrink: 0;
    margin-left: @size-small;
    font-size: @size-small;
    color: @color-gray-light;
  }

  .filter-item-content {
    display: none;
    &.active {
      display: block;
      max-width: @size-ignore-max-width;
      width: 100%;
      height: 100%;
      background: fade(@color-black, 30%);
      position: absolute;
      left: 0;
      z-index: @z-index-extra-extra-large;
    }
  }

  .block-list {
    padding-top: @size-base;
    padding-bottom: @size-base / 2;
    background: @color-white;
  }

  .filter-list-block {
    &:not(:first-child) {
      padding-top: @size-large;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      margin-bottom: @size-base;
      position: relative;
      font-weight: @font-weight-bold;
      font-size: @font-size-medium;
      color: @color-text-base;
      text-align: center;
      line-height: 1;
      &.center {
        &:after {
          content: '';
          position: absolute;
          width: @size-medium;
          height: 1px;
          background: @color-text-light;
          right: -@size-large;
          top: 50%;
        }
        &:before {
          content: '';
          position: absolute;
          width: @size-medium;
          height: 1px;
          background: @color-text-light;
          left: -@size-large;
          top: 50%;
        }
      }
      &.left {
        padding-left: @size-base;
        align-self: flex-start;
        font-weight: @font-weight-primary;
        font-size: @font-size-base;
        color: @color-text-lighter;
      }
    }
    .option-list {
      width: 100%;
      padding-left: @size-base;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
    }
    .option-item {
      width: 220px;
      height: 80px;
      margin-right: @size-extra-small + @size-extra-small / 2;
      margin-bottom: @size-extra-small + @size-extra-small / 2;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-gray-lightest;
      border-radius: @border-radius-normal;
      color: @color-text-base;
      font-size: @font-size-base;
      &.active {
        box-sizing: border-box;
        background: @color-primary-lighter;
        color: @color-primary-aide;
        border: @border-width-base @border-style-base @color-primary-aide;
      }
    }
  }

  .tool-bar {
    display: flex;
    justify-content: space-between;
    .cancel,
    .reset,
    .confirm {
      height: 100px;
      line-height: 100px;
      flex: 1;
      text-align: center;
      font-size: @font-size-medium;
    }
    .cancel,
    .reset {
      background: @color-white;
      color: @color-primary-aide;
      border-top: @border-base;
    }
    .confirm {
      background: @color-primary-aide;
      color: @color-white;
    }
  }

</style>
